import {
  AfterContentInit,
  ChangeDetectorRef,
  Component,
  ContentChild,
  ContentChildren,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  QueryList,
  SimpleChanges
} from '@angular/core';
import {
  TabHeaderData,
  TabHeadersConfig,
  TabHeadersContent
} from '../../../models';
import { PositionTopOrBottom } from '../../../types/common.types';
import { TabHeadersComponent } from '../../atoms/tab-headers/tab-headers.component';
import { TabComponent } from '../../atoms/tab/tab.component';

@Component({
  selector: 'idp-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss']
})
export class TabsComponent implements AfterContentInit, OnChanges {
  // config and content for header
  headerData: TabHeaderData = {
    config: {} as TabHeadersConfig,
    content: {} as TabHeadersContent
  };

  @ContentChildren(TabComponent, { descendants: false })
  tabs: QueryList<TabComponent> = {} as QueryList<TabComponent>;

  @ContentChild(TabHeadersComponent, { read: true }) tabHeaders = {};
  /**
   * Takes either the string value 'top' or 'bottom' to place TabHeader
   * relative to the `TabPanel`s.
   */
  @Input() position: PositionTopOrBottom = 'top';
  /**
   * Set to 'true' to have tabs automatically activated and have their content displayed when they receive focus.
   */
  @Input() followFocus = true;
  /**
   * Set to `true` to have the tabIndex of the all tabpanels be -1.
   */
  @Input() isNavigation = false;
  /**
   * Sets the aria label on the `TabHeader`s nav element.
   */
  @Input() ariaLabel = '';
  /**
   * Sets the aria labelledby on the `TabHeader`s nav element.
   */
  @Input() ariaLabelledby = '';

  @Output() selected: EventEmitter<number> = new EventEmitter<number>();

  constructor(private cdf: ChangeDetectorRef) {}

  setHeaderConfig(followFocus: boolean): TabHeadersConfig {
    return { followFocus };
  }

  setHeaderContentDisplayValues(
    content: TabHeadersContent,
    ariaLabel: string,
    ariaLabelledby: string
  ): TabHeadersContent {
    return {
      ...content,
      ariaLabel,
      ariaLabelledby
    };
  }

  setHeaderContentTabElements(
    content: TabHeadersContent,
    tabs: QueryList<TabComponent>
  ): TabHeadersContent {
    return {
      ...content,
      tabs
    };
  }

  ngAfterContentInit() {
    this.headerData.content = this.setHeaderContentTabElements(
      this.headerData.content,
      this.tabs
    );
    // this.tabs = new QueryList<TabComponent>();
    this.setTabs();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.headerData.config = this.setHeaderConfig(this.followFocus);
    this.headerData.content = this.setHeaderContentDisplayValues(
      this.headerData.content,
      this.ariaLabel,
      this.ariaLabelledby
    );
    if (this.tabs && changes['isNavigation']) {
      this.setTabs();
    }
  }

  /**
   * true if the idp-n-tab's are passed directly to the component as children
   */
  hasTabHeaders() {
    return this.tabs.length > 0;
  }

  setTabs() {
    if (this.tabs.length) {
      this.tabs.forEach((tab) => {
        tab.content.tabIndex = this.isNavigation ? null : 0;
      });
      this.cdf.detectChanges();
    }
  }

  setCurrentTab(currentTab: number) {
    this.selected.emit(currentTab);
  }
}
